import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

/**
 * Gamla värdnamn (t.ex. den indexerade stagingsajten på Azure) ska aldrig
 * svara med eget innehåll. Om trafik når oss via ett sådant värdnamn skickas
 * den vidare med 301 till produktionsdomänen så att länkvärde konsolideras.
 */
const LEGACY_HOSTS = new Set([
  "app-elmarknad-stage.azurewebsites.net",
]);

const canonicalHostMiddleware = createMiddleware().server(async ({ next, request }) => {
  try {
    const { warmSeoOverrides } = await import("./lib/seoMeta.server");
    await warmSeoOverrides();
  } catch {
    // SEO-överskrivningar är valfria
  }
  try {
    const url = new URL(request.url);
    if (LEGACY_HOSTS.has(url.hostname.toLowerCase())) {
      return new Response(null, {
        status: 301,
        headers: { location: `https://elmarknad.se${url.pathname}${url.search}` },
      });
    }
  } catch {
    // ignorera – fortsätt som vanligt
  }
  return await next();
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [canonicalHostMiddleware, errorMiddleware],
}));

